import axios from "../axios-auth";

export const getData = async (url, params) => {
  const response = await axios.get(url, {
    params,
  });
  return response.data;
};
